<igx-snackbar [positionSettings]="newPositionSettings" #snackbar>{{msg}}
  <svg id="dots" height="20px" *ngIf="loading">
    <g id="dots" fill="#999999">
        <circle id="dot1" cx="5" cy="18" r="2"></circle>
        <circle id="dot2" cx="15" cy="18" r="2"></circle>
        <circle id="dot3" cx="25" cy="18" r="2"></circle>
    </g>
</svg></igx-snackbar>
